import React, { Dispatch, SetStateAction } from "react";
import { useTranslation } from "react-i18next";
import {
  formatDateToInput,
  formatIfISO,
  getCurrentDateTimeLocal,
  hasEmptyField,
  openBase64ImageInNewTab,
} from "../../utils/helpers";
import { ImageDrawerComponent } from "../imageDrawerComponent";
import uploadAnim from "../../animations/upload.json";
import { set } from "react-hook-form";
import { RiCloseCircleFill, RiCloseCircleLine } from "react-icons/ri";
import { uploadProfileImage } from "../../utils/Api/uploadApi";
import { date } from "yup";
import Swal from "sweetalert2";
import moment from "moment";
import { createEvent, updateEventByiD } from "../../utils/Api/eventsApi";
import { useParams } from "react-router-dom";
import ToastSwal from "../toastSwal";
import { create } from "domain";

interface EventComponentProps {
  isOpen: boolean;
  SetOpen: Dispatch<SetStateAction<boolean>>;
  title: string;
  ClubList: any[];
  DataEvent?: EventProps;
}

type EventProps = {
  id?:number;
  eventname: string;
  eventdate: string;
  id_club: number;
  eventinitdate: string;
  eventenddate: string;
  urlimage: string;
  lives?:[];
  streams?:[],

};

const EventComponent = ({
  SetOpen,
  DataEvent,
  title,
  ClubList,
}: EventComponentProps) => {
  const [t] = useTranslation("global");
  const [selectedValues, setSelectedValues] = React.useState<EventProps>();
  const [loadImage, setLoadImage] = React.useState<boolean>(false);
  const params = useParams();
  const eventId = params;

  React.useEffect(() => {
   if(DataEvent){
    setSelectedValues(DataEvent);
   }
  }, [DataEvent])
  

  const handleOnChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value, type } = event.target;
    switch (type) {
      case "text":
        setSelectedValues({ ...selectedValues, [name]: value });
        break;
      case "select-one":
        setSelectedValues({ ...selectedValues, [name]: value });
        break;
      case "file":
        setSelectedValues({ ...selectedValues, [name]: value });
        break;
      case "datetime-local":
        if (name === "eventenddate" || name === "eventinitdate") {
          setSelectedValues((prev) => ({
            ...prev,
            [name]: value,
            eventdate: name === "eventinitdate" ? value : prev.eventdate,
          }));
          return;
        }
        break;
      default:
        break;
    }
  };

  const uploadImageToBucket = async (file: File) => {
    try {
      setLoadImage(true);
      const updatedUrl = await uploadProfileImage(file);
      if (!updatedUrl) return;
      setSelectedValues((prev) => ({
        ...prev,
        urlimage: updatedUrl?.data.url,
      }));
    } catch (error) {
      console.error("Hubo un problema al cargar la imagen", error?.message);
    } finally {
      setLoadImage(false);
    }
  };

  function isDisabled ():boolean{
    if(selectedValues){
      const {eventname,...restFields} = selectedValues;
      const isValid = hasEmptyField(restFields);
      return isValid;
    }
  }



  const onSubmitData = () => {
    if (isDisabled()) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: `${t("Events.requiredFields")}`,
      });
      return;
    }
    selectedValues.eventdate = formatIfISO(
      selectedValues.eventdate,
      "DD-MM-YYYY"
    );
    selectedValues.eventenddate = formatIfISO(
      selectedValues.eventenddate,
      "DD-MM-YYYY"
    );
    selectedValues.eventinitdate = formatIfISO(
      selectedValues.eventinitdate,
      "DD-MM-YYYY"
    );
    const initTime = moment.parseZone(selectedValues.eventinitdate).format("HH:mm");
    const endTime =moment.parseZone(selectedValues.eventenddate).format("HH:mm");
    const values = {
      eventname: selectedValues.eventname,
      eventdate: selectedValues.eventdate,
      id_club: Number(selectedValues.id_club),
      eventenddate: selectedValues.eventenddate,
      eventendtime: selectedValues.eventenddate,
      eventinittime: selectedValues.eventinitdate,
      eventinitdate: selectedValues.eventinitdate,
      urlimagen: selectedValues.urlimage,
    };
    Swal.fire({
      title: `${!DataEvent ? t("Events.Modals.title1"): t("Events.Modals.title2")}`,
      text: `${t("Events.Modals.description2")} ${moment(
        selectedValues.eventdate
      ).format("DD-MM-YYYY")} ${t("Events.Modals.time")} ${moment(
        initTime,
        "HH:mm:ss"
      ).format("HH:mm")} ${t("Events.Modals.to")} ${moment(
        selectedValues.eventenddate
      ).format("DD-MM-YYYY")} ${t("Events.Modals.time")} ${moment(
        endTime,
        "HH:mm:ss"
      ).format("HH:mm")}`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: `${!DataEvent ? t("Events.Buttons.create"): t("Events.Buttons.update")}`,
      cancelButtonText: `${t("Events.Buttons.cancel")}`,
      confirmButtonColor: "#060707",
      cancelButtonColor: "#f44336",
      didDestroy: () => {
        Swal.close();
      },
    })
      .then(async (result) => {
        const isEditing = DataEvent && Object.keys(DataEvent).length > 0 && !!DataEvent.id_club;
        console.log('Que devuelve isEditing?',isEditing);

        if (result.isConfirmed) {
          const response = isEditing
            ? await updateEventByiD(DataEvent.id, {...values })
            : await createEvent(values);
        
          if (response.status >= 200 && response.status <= 400) {
            ToastSwal({
              icon: "success",
              title: `Evento ${values.eventname} ${isEditing ? "actualizado" : "creado"} con éxito`,
              positions: "bottom-end",
              timer: 3000,
              timeProgressBar: false,
            });
            SetOpen(false);
            setTimeout(() => window.location.reload(), 2000);
          }
        }
        
      })
      .catch((error) => {
        console.error("Hubo un error al crear el evento", error.message);
      });
  };
  return (
    <div
      className="absolute top-0 w-full h-full bg-[rgba(0,0,0,0.8)] shadow-sm z-100"
      aria-labelledby={title}
      role="dialog"
      aria-modal="true"
    >
      <div className="flex flex-col items-center justify-center max-w-2xl p-6 mx-auto mt-40 bg-white rounded-md shadow-md ">
        <div className="flex flex-row items-center justify-between w-full">
          <h2 className="text-2xl font-semibold ">{title}</h2>
          <RiCloseCircleLine
            size={25}
            className="cursor-pointer hover:text-red-500"
            onClick={() => SetOpen(false)}
          />
        </div>
        <div className="flex flex-col items-center justify-start w-full mt-3 text-center">
          <input
            type="text"
            name="eventname"
            className={
              `w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500` +
              (!selectedValues?.eventname && " border-red-500")
            }
            value={selectedValues?.eventname || ""}
            onChange={handleOnChange}
            placeholder={t("Events.nameEvent")}
          />
          {/* {!selectedValues?.eventname && (
            <p className="mt-2 font-sans font-semibold text-red-500">
              * {t("Events.fieldRequired")}
            </p>
          )} */}
        </div>

        <div className="flex flex-row items-center justify-start w-full mt-6 text-center">
          <div className="flex flex-col items-center justify-start w-1/2">
            <p className="text-base font-medium text-center text-neutral-700">
              {t("Events.startEvent")}
            </p>
            <input
              type="datetime-local"
              name="eventinitdate"
              className={
                `w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500` +
                (!selectedValues?.eventinitdate && " border-red-500")
              }
              value={selectedValues?.eventinitdate || ""}
              onChange={handleOnChange}
              min={getCurrentDateTimeLocal()}
            />
            {!selectedValues?.eventinitdate && (
              <p className="mt-2 font-sans font-semibold text-red-500">
                * {t("Events.fieldRequired")}
              </p>
            )}
          </div>
          <div className="flex flex-col items-center justify-start w-1/2 ml-10">
            <p className="text-base font-medium text-center text-neutral-700">
              {t("Events.endEvent")}
            </p>
            <input
              type="datetime-local"
              name="eventenddate"
              className={
                `w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500` +
                (!selectedValues?.eventenddate && " border-red-500")
              }
              value={selectedValues?.eventenddate || null}
              onChange={handleOnChange}
              min={selectedValues?.eventinitdate || new Date().toISOString()}
            />
            {!selectedValues?.eventenddate && (
              <p className="mt-2 font-sans font-semibold text-red-500">
                * {t("Events.fieldRequired")}
              </p>
            )}
          </div>
        </div>

        <div className="flex flex-col items-center justify-start w-full mt-3 text-center">
          <p className="text-base font-medium text-center text-neutral-700">
            {t("Events.club")}
          </p>
          <select
            className={`w-full p-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 ${
              !selectedValues?.id_club ? "border-red-500" : "border-gray-300"
            }`}
            value={selectedValues?.id_club || ""}
            name="id_club"
            role="combobox"
            onChange={handleOnChange}
          >
            <>
              <option value="" disabled>
                {"Seleccione un club"}
              </option>
              {ClubList?.map((club, key) => (
                <option key={club?.value + key} value={club?.value}>
                  {club?.label}
                </option>
              ))}
            </>
          </select>
          {!selectedValues?.id_club && (
            <p className="mt-2 font-sans font-semibold text-red-500">
              * {t("Events.fieldRequired")}
            </p>
          )}
        </div>

        <div className="flex flex-col items-center justify-start w-full mt-3 text-center">
          <ImageDrawerComponent
            name="eventUrlImage"
            label={t("Events.image")}
            loadImage={loadImage}
            description={t("Events.clickorDrag")}
            errorText={t("Events.clickorDrag_description")}
            error={selectedValues?.urlimage === null}
            initialPreview={selectedValues?.urlimage || ''}
            imgLoader={uploadAnim}
            acceptedTypes={[
              "image/jpeg",
              "image/png",
              "image/jpg",
              "image/gif",
              "image/avif"
            ]}
            onImageSelected={(file, preview) => uploadImageToBucket(file)}
          />
        </div>
        {selectedValues?.urlimage === null && (
          <p className="mt-2 font-sans font-semibold text-red-500">
            * {t("Events.fieldRequired")}
          </p>
        )}

        <div className="flex flex-row items-center justify-between w-full px-20 mt-5">
          <button
            className="p-4 font-medium text-white bg-red-500 rounded-md hover:bg-red-700 hover:text-gray-500 "
            onClick={() => SetOpen(false)}
            type="button"
          >
            {t("Events.Buttons.cancel")}
          </button>
          <button
            className="p-4 text-white bg-black rounded-md hover:bg-slate-300 hover:text-black disabled:bg-slate-300 disabled:text-black"
            onClick={onSubmitData}
            disabled={isDisabled()}
          >
            {!DataEvent ?t("Events.Buttons.create"): t("Events.Buttons.update")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default EventComponent;
